import { Link } from "react-router-dom";
import { Instagram, Facebook, MessageCircle, MapPin, Heart } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";
import { Logo } from "@/components/store/Logo";

const PAGES = [
  { to: "/", label: "Inicio" },
  { to: "/tienda", label: "Tienda" },
  { to: "/blog", label: "Blog" },
  { to: "/como-comprar", label: "Cómo comprar" },
  { to: "/nosotros", label: "Nosotros" },
];

export const Footer = () => {
  const { settings } = useSettings();

  return (
    <footer className="mt-16 bg-charcoal text-cream">
      <div className="max-w-6xl mx-auto px-4 py-12 grid grid-cols-1 md:grid-cols-3 gap-8">
        <div>
          <div className="flex items-center gap-2 font-display text-xl font-bold mb-3">
            <Logo size={36} />
            {settings.store_name}
          </div>
          <p className="text-sm text-cream/70 leading-relaxed">{settings.tagline}</p>
          <div className="flex gap-2 mt-4">
            <a href={settings.instagram_url} target="_blank" rel="noopener noreferrer" data-testid="footer-instagram" className="grid place-items-center w-9 h-9 rounded-xl bg-cream/10 hover:bg-coral transition-colors" aria-label="Instagram"><Instagram className="w-4 h-4" /></a>
            <a href={settings.facebook_url} target="_blank" rel="noopener noreferrer" data-testid="footer-facebook" className="grid place-items-center w-9 h-9 rounded-xl bg-cream/10 hover:bg-coral transition-colors" aria-label="Facebook"><Facebook className="w-4 h-4" /></a>
            <a href={`https://wa.me/${settings.whatsapp_number}`} target="_blank" rel="noopener noreferrer" className="grid place-items-center w-9 h-9 rounded-xl bg-cream/10 hover:bg-teal hover:text-charcoal transition-colors" aria-label="WhatsApp"><MessageCircle className="w-4 h-4" /></a>
          </div>
        </div>

        <div>
          <h4 className="font-display font-bold mb-3">Enlaces</h4>
          <ul className="space-y-2 text-sm text-cream/70">
            {PAGES.map((p) => (
              <li key={p.to}><Link to={p.to} className="hover:text-coral">{p.label}</Link></li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-display font-bold mb-3">Contacto</h4>
          <ul className="space-y-2 text-sm text-cream/70">
            <li className="flex items-start gap-2"><MapPin className="w-4 h-4 mt-0.5 text-teal shrink-0" /> {settings.country}</li>
            <li className="flex items-start gap-2"><MessageCircle className="w-4 h-4 mt-0.5 text-teal shrink-0" /> +{settings.whatsapp_number}</li>
            <li className="flex items-start gap-2"><Instagram className="w-4 h-4 mt-0.5 text-teal shrink-0" /> @petshoppingcompany</li>
            <li className="flex items-start gap-2"><Heart className="w-4 h-4 mt-0.5 text-coral shrink-0" /> 10% de utilidades para casas cuna</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-cream/10">
        <div className="max-w-6xl mx-auto px-4 py-4 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-center text-xs text-cream/50">© 2026 The Pet Shopping Co SA Costa Rica</p>
          <Link to="/admin" data-testid="footer-admin-link" className="text-xs text-cream/40 hover:text-coral transition-colors">Administrador</Link>
        </div>
      </div>
    </footer>
  );
};
